import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '每日大赛', path: '/category/all' },
  { label: '网红塌房', path: '/category/all' },
  { label: '博主反差', path: '/category/all' },
  { label: '热门事件', path: '/category/all' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className={`font-heading text-2xl md:text-3xl font-bold tracking-tight transition-colors duration-300 ${
              scrolled ? 'text-primary-500' : 'text-background-50'
            }`}>
              吃瓜网站
            </span>
          </Link>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium whitespace-nowrap transition-colors duration-300 py-1 ${
                  scrolled
                    ? location.pathname === link.path
                      ? 'text-primary-500'
                      : 'text-foreground-700 hover:text-primary-500'
                    : location.pathname === link.path
                      ? 'text-background-50'
                      : 'text-background-50/80 hover:text-background-50'
                }`}
              >
                {link.label}
                {location.pathname === link.path && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-primary-500 rounded-full" />
                )}
              </Link>
            ))}
          </div>

          {/* Right actions */}
          <div className="hidden md:flex items-center gap-4">
            <button
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-300 cursor-pointer ${
                scrolled
                  ? 'text-foreground-600 hover:text-primary-500 hover:bg-primary-50'
                  : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg" />
            </button>
            <Link
              to="/about"
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap border transition-all duration-300 cursor-pointer ${
                scrolled
                  ? 'border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-background-50'
                  : 'border-background-50 text-background-50 hover:bg-background-50 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-700' : 'text-background-50'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {/* Mobile menu panel */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'bg-primary-50 text-primary-500'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="border-t border-background-200 pt-3 mt-2">
              <Link
                to="/about"
                className="block w-full text-center px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}